import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'app/core/authentication/authentication.service';
import { catchError, debounceTime, interval, Observable, of, Subscription, switchMap, takeWhile, tap } from 'rxjs';

@Component({
  selector: 'verify-modal',
  templateUrl: './verify-modal.component.html',
  styleUrls: ['./verify-modal.component.scss']
})
export class VerifyModalComponent implements OnInit, OnDestroy {

  @Input() clientID: any;
  private verified: Subscription;
  isLoading: boolean = true;
  visibilityChangeEventListener: any;

  constructor(public activeModal: NgbActiveModal, private authService: AuthService, private router: Router) {
  }

  ngOnInit(): void {
    this.visibilityChangeEventListener = this.handleVisibilityChange.bind(this);
    document.addEventListener('visibilitychange', this.visibilityChangeEventListener);

    this.startPolling();
  }

  handleVisibilityChange(): void {
    if (document.visibilityState === 'visible') {
      this.getVerification(this.clientID).subscribe();
      this.startPolling();
    } else {
      this.stopPolling();
    }
  }

  startPolling(): void {
    if (this.verified) {
      this.verified.unsubscribe();
    }
  
    this.verified = interval(500).pipe(
      debounceTime(500),
      switchMap(() => this.getVerification(this.clientID))
    ).subscribe();
  }

  getVerification(clientID: number): Observable<void> {
    return this.authService.getVerification(clientID).pipe(
      tap(res => {
        console.log(res);
        if (res.message === 'Email Verified') {
          this.authService.registered = true;
          localStorage.setItem('email', res.email);
          this.router.navigate(['plan'], { replaceUrl: true });
          this.stopPolling();
          this.closeModal();
        }
      }),
      catchError(err => {
        console.log(err);
        return of();
      })
    );
  }

  stopPolling() {
    this.isLoading = false;
    if (this.verified) {
      this.verified.unsubscribe();
    }
  }

  closeModal() {
    this.activeModal.close();
  }

  ngOnDestroy(): void {
    this.stopPolling();
    document.removeEventListener('visibilitychange', this.visibilityChangeEventListener);
  }
}
